import { CategoryInterface } from '../../../../../common/types/interfaces'
import { Item } from '../item/Item'
import classes from './List.module.sass'

type Props = {
  startEdit: (el: CategoryInterface) => void
  showDetails: (el: CategoryInterface) => void
  list: CategoryInterface[] | []
  loading: boolean
  startDuplicate: (el: CategoryInterface) => void
}

export const List = ({ startEdit, list, showDetails, loading, startDuplicate }: Props) => {
  return (
    <div className={classes.container}>
      {!list?.length && !loading ? (
        <div className={classes.Message}>Нет категорий</div>
      ) : (
        list.map((el) => (
          <Item
            showDetails={showDetails}
            el={el}
            startEdit={startEdit}
            key={el.id}
            startDuplicate={startDuplicate}
          />
        ))
      )}
    </div>
  )
}
